import { atom } from 'recoil';

export type TrainingFileOpenTableAtom = number[];

export const trainingFileOpenTableAtom = atom<TrainingFileOpenTableAtom>({
	key: 'trainingFileOpenTable',
	default: [],
});
